import React from 'react';
import { Button } from '@chakra-ui/react';
import { FiEyeOff } from 'react-icons/fi';
import { useAppearance } from '../theme/AppearanceProvider';

// item 327 — the quiet-but-visible "numbers are hidden" pill while stealth mode is on
// (bottom-right, everywhere). Click = turn stealth off. Deliberately NOT loud — this
// shows during client demos, so it must not draw the room's attention the way the
// impersonation banner does.
const StealthIndicator: React.FC = () => {
  const { stealth, setStealth } = useAppearance();
  if (!stealth) return null;
  return (
    <Button
      position="fixed"
      bottom="18px"
      right="18px"
      zIndex={2000}
      size="sm"
      leftIcon={<FiEyeOff />}
      bg="blackAlpha.700"
      color="whiteAlpha.900"
      _hover={{ bg: 'blackAlpha.800' }}
      borderRadius="full"
      boxShadow="0 8px 28px rgba(0,0,0,0.45)"
      onClick={() => setStealth(false)}
      title="Stealth mode is hiding every number — click to show them again"
    >
      STEALTH
    </Button>
  );
};

export default StealthIndicator;
